
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricMotorAc as ObiElectricMotorAcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-motor-ac.js';
 
 
 

 
 export const ObiElectricMotorAc = createComponent({
   react: React,
   tagName: 'obi-electric-motor-ac',
   elementClass: ObiElectricMotorAcElement,
   events: {
     
   }
  });
 
 